"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.copyright-container p {\n  font-size: 12px;\n  padding: 16px; }\n";
  const fileName = "Copyright_Copyright";
  const element = document.querySelector("style[data-sass-component='Copyright_Copyright']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Copyright = _ref => {
  let {
    title,
    copyright,
    copyrightSimbol,
    titleVideo,
    copyrightVideo
  } = _ref;
  const isVideo = !!titleVideo;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "copyright-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11"
  }, title, " ", title && copyright && !isVideo && '/ ', copyright && `${copyrightSimbol || '©'} ${copyright}`, isVideo && ' / ', titleVideo, ' ', copyrightVideo && `${copyrightSimbol || '©'} ${copyrightVideo}`));
};
Copyright.propTypes = {
  title: _propTypes.default.string,
  copyright: _propTypes.default.string,
  copyrightSimbol: _propTypes.default.string,
  titleVideo: _propTypes.default.string,
  copyrightVideo: _propTypes.default.string
};
Copyright.defaultProps = {
  copyrightSimbol: '©'
};
var _default = exports.default = Copyright;